module.exports = __webpack_public_path__ + "img/ecg_box_img.62a58ec9.png";